import { render } from "./productsList.vue?vue&type=template&id=1e774f6c"
import script from "./productsList.vue?vue&type=script&lang=js"
export * from "./productsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__